module.exports = __webpack_public_path__ + "images/phone19f469a36ada250ad896e24ad4243ffa.png";